import { createApp } from 'vue';
import App from '@/App.vue';
import router from '@/router';
import store from '@/store/store';
import i18n from '@/i18n';
import { filters } from '@/common/filters';
import { Swiper, SwiperSlide } from 'swiper/vue/swiper-vue';
import { Navigation } from 'swiper';
import { Pagination } from 'swiper';
import { SetupCalendar, DatePicker } from 'v-calendar';
import dayjs from 'dayjs';
import VueQrcode from 'vue-qrcode';
import PerfectScrollbar from 'vue3-perfect-scrollbar';
import 'shepherd.js/dist/css/shepherd.css';
import VueSmoothScroll from 'vue3-smooth-scroll';

import 'bootstrap/dist/js/bootstrap.bundle.min.js';

// custom style
import '@/assets/css/NewUICss/index.css';

const app = createApp(App);
app.use(SetupCalendar, {
	masks: { title: 'MMM YYYY', input: 'YYYY.MM.DD' },
});

app.use(router).use(store).use(i18n).use(PerfectScrollbar).use(VueSmoothScroll);
app.component('DatePicker', DatePicker);
app.component('Swiper', Swiper);
app.component('SwiperSlide', SwiperSlide);
app.component('Navigation', Navigation);
app.component('Pagination', Pagination);
app.component('Qrcode', VueQrcode);
app.mount('#app');

app.config.globalProperties.$filters = filters;
app.config.globalProperties.$dayjs = dayjs;
if (/iphone/.test(navigator.userAgent.toLowerCase())) {
	document
		.querySelector('#viewport')
		.setAttribute(
			'content',
			'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0',
		);
}
